import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd034aService,
  Sgkd034aRequest,
  Sgkd034aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd034aService {

  private _rsesult$ = new Subject<Sgkd034aResponse>();
  constructor(private sgkd034aService: Sgkd034aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 住所情報・お客さま氏名取得API呼び出し
   * 
   * @param shutokutargetTablediv 取得対象テーブル区分
   * @param recptFixNo 請求お客さま番号
   * @param firstSrvctrNo 契約お客さま番号
   * @param date 日付
   * @memberof UsedSgkd002dSgkd034aService
   */
  doSgkd034a(shutokutargetTablediv:string, firstSrvctrNo:string, recptFixNo: string, date: string): Observable<Sgkd034aResponse> {
  
      // リクエスト生成
      let request: Sgkd034aRequest = {
        requestDto: {
          /** 取得対象テーブル区分 */
          shutokutargetTablediv: shutokutargetTablediv,
          /** 参照先テーブル区分 */
          referencedbyTablediv: SgKdConstants.CODE_REFBYTBLDIV_1,
          /** 請求お客さま番号 */
          ...(recptFixNo != null && { recptFixNo: recptFixNo }),
          /** 契約お客さま番号 */
          ...(firstSrvctrNo != null && { firstSrvctrNo: firstSrvctrNo }),
          /** 基準日付 */
          stdday: date
        }
      };
  
      return this.sgkd034aService.doSGKD034APost(this.apiCommonService.setRequestCommon(request), 'response')
        // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
        .pipe(
          map(response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            this._rsesult$.next(response.body);
            return response.body;
            //return true;
          }),
          timeout(Number(this.featuresLibConfig.httpTimeout)),
          catchError((err) => {
            this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD034A');
            return throwError(err.message);
          }
        )
      );
    }

}
